var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF4949"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.255 8.263a.895.895 0 0 1 1.258-.01L16 14.581l6.488-6.328a.895.895 0 0 1 1.257.01.875.875 0 0 1-.01 1.246L17.08 16l6.655 6.491c.35.342.354.9.01 1.246a.895.895 0 0 1-1.258.01L16 17.419l-6.487 6.328a.895.895 0 0 1-1.258-.01.875.875 0 0 1 .01-1.246L14.92 16 8.265 9.509a.875.875 0 0 1-.01-1.246Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.b6424a954b5da565187cd8b7911f60c2.svg";
export { ForwardRef as ReactComponent };